"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWorkerTask = exports.getUploadCompleteTask = exports.getAndPutFilePartTask = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _docsHttpClient = require("@adsk/docs-http-client");
var _common = require("./common");
var _consts = require("./consts");
var _file = require("./file");
var getAndPutFilePartTask = exports.getAndPutFilePartTask = function getAndPutFilePartTask(_ref) {
  var queue = _ref.queue,
    httpService = _ref.httpService,
    onUpdateStatus = _ref.onUpdateStatus;
  var _getWaitingForUpload = (0, _file.getWaitingForUpload)(queue),
    _getWaitingForUpload2 = (0, _slicedToArray2["default"])(_getWaitingForUpload, 2),
    part = _getWaitingForUpload2[0],
    file = _getWaitingForUpload2[1];
  if (!part) {
    return null;
  }
  onUpdateStatus({
    id: part.id,
    fileId: part.fileId,
    status: _consts.UPLOAD_STATUS.UPLOAD_CONTENT
  });
  var cancelRequestConfig = {
    getter: function getter() {
      return _consts.ossCancelTokenMap.get(part.id);
    },
    setter: function setter(tokenId) {
      return _consts.ossCancelTokenMap.set(part.id, tokenId);
    },
    clearer: function clearer() {
      return _consts.ossCancelTokenMap["delete"](part.id);
    }
  };
  var task = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var payload, options, _yield$httpService$ge, _yield$httpService$ge2, uploadExpiration, uploadKey, urlExpiration, urls, url, handleProgress, chunk, blob;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            payload = {
              bucketKey: file.bucketKey,
              objectKey: file.objectKey,
              firstPart: part.part
            };
            if (file.uploadKey) {
              payload.uploadKey = file.uploadKey;
            }
            options = Object.assign((0, _defineProperty2["default"])({}, _docsHttpClient.CANCEL_KEYS, cancelRequestConfig), file.options);
            _context.prev = 3;
            _context.next = 6;
            return httpService.getSignedUrl(payload, options);
          case 6:
            _yield$httpService$ge = _context.sent;
            _yield$httpService$ge2 = _yield$httpService$ge.data;
            uploadExpiration = _yield$httpService$ge2.uploadExpiration;
            uploadKey = _yield$httpService$ge2.uploadKey;
            urlExpiration = _yield$httpService$ge2.urlExpiration;
            urls = _yield$httpService$ge2.urls;
            url = urls[0]; // only one url in urls
            onUpdateStatus({
              id: part.id,
              fileId: part.fileId,
              url: url,
              urlExpiration: urlExpiration,
              uploadExpiration: uploadExpiration,
              uploadKey: uploadKey
            });
            handleProgress = function handleProgress(progress) {
              onUpdateStatus({
                id: part.id,
                fileId: part.fileId,
                progress: progress
              });
            };
            if (!(0, _common.isBrowser)()) {
              _context.next = 26;
              break;
            }
            if (!(0, _common.isDataURIScheme)(file.ref)) {
              _context.next = 20;
              break;
            }
            chunk = (0, _file.getDataURISchemeChunk)(file.ref, part.part, file.fileChunkSize);
            _context.next = 24;
            break;
          case 20:
            blob = (0, _file.getFileBlob)(file.ref, part.part, file.fileChunkSize);
            _context.next = 23;
            return (0, _file.readBlob)(blob);
          case 23:
            chunk = _context.sent;
          case 24:
            _context.next = 35;
            break;
          case 26:
            if (!(0, _common.isNode)()) {
              _context.next = 35;
              break;
            }
            if (!(0, _common.isFile)(file.ref)) {
              _context.next = 31;
              break;
            }
            chunk = (0, _file.getFileBlob)(file.ref, part.part, file.fileChunkSize);
            _context.next = 35;
            break;
          case 31:
            if (!(0, _common.isFilePath)(file.ref)) {
              _context.next = 35;
              break;
            }
            _context.next = 34;
            return (0, _file.readFileChunk)(file.ref, part.part, file.fileChunkSize);
          case 34:
            chunk = _context.sent;
          case 35:
            if (chunk) {
              _context.next = 37;
              break;
            }
            throw {
              code: _consts.ERROR.FILE_INVALID,
              detail: file.ref
            };
          case 37:
            _context.next = 39;
            return httpService.putToSignedUrl(url, chunk, handleProgress, (0, _defineProperty2["default"])({}, _docsHttpClient.CANCEL_KEYS, cancelRequestConfig));
          case 39:
            onUpdateStatus({
              id: part.id,
              fileId: part.fileId,
              status: _consts.UPLOAD_STATUS.UPLOAD_CONTENT_SUCCESS
            });
            _context.next = 45;
            break;
          case 42:
            _context.prev = 42;
            _context.t0 = _context["catch"](3);
            onUpdateStatus({
              id: part.id,
              fileId: part.fileId,
              status: _consts.UPLOAD_STATUS.UPLOAD_CONTENT_FAILED,
              error: _context.t0
            });
          case 45:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 42]]);
    }));
    return function task() {
      return _ref2.apply(this, arguments);
    };
  }();
  return task;
};
var getUploadCompleteTask = exports.getUploadCompleteTask = function getUploadCompleteTask(_ref3) {
  var queue = _ref3.queue,
    httpService = _ref3.httpService,
    onUpdateStatus = _ref3.onUpdateStatus;
  var file = (0, _file.getToCompleteFile)(queue);
  if (!file) return undefined;
  onUpdateStatus({
    id: file.id,
    status: _consts.UPLOAD_STATUS.COMPLETE_UPLOAD_PENDING
  });
  var payload = {
    bucketKey: file.bucketKey,
    objectKey: file.objectKey,
    uploadKey: file.uploadKey,
    size: file.size
  };
  var options = Object.assign((0, _defineProperty2["default"])({}, _docsHttpClient.CANCEL_KEYS, {
    getter: function getter() {
      return _consts.ossCancelTokenMap.get(file.id);
    },
    setter: function setter(tokenId) {
      return _consts.ossCancelTokenMap.set(file.id, tokenId);
    },
    clearer: function clearer() {
      return _consts.ossCancelTokenMap["delete"](file.id);
    }
  }), file.options);
  var task = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var _yield$httpService$co, data;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return httpService.completeUpload(payload, options);
          case 3:
            _yield$httpService$co = _context2.sent;
            data = _yield$httpService$co.data;
            onUpdateStatus({
              id: file.id,
              status: _consts.UPLOAD_STATUS.COMPLETE_UPLOAD_SUCCESS,
              res: data
            });
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            onUpdateStatus({
              id: file.id,
              status: _consts.UPLOAD_STATUS.COMPLETE_UPLOAD_FAILED,
              error: _context2.t0
            });
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return function task() {
      return _ref4.apply(this, arguments);
    };
  }();
  return task;
};

/**
 * task priority
 * 1. upload complete task
 * 2. file part task
 *
 */
var getWorkerTask = exports.getWorkerTask = function getWorkerTask(_ref5) {
  var queue = _ref5.queue,
    httpService = _ref5.httpService,
    onUpdateStatus = _ref5.onUpdateStatus;
  var uploadCompleteTask = getUploadCompleteTask({
    queue: queue,
    httpService: httpService,
    onUpdateStatus: onUpdateStatus
  });
  if (uploadCompleteTask) {
    return uploadCompleteTask;
  }
  var filePartTask = getAndPutFilePartTask({
    queue: queue,
    httpService: httpService,
    onUpdateStatus: onUpdateStatus
  });
  if (filePartTask) {
    return filePartTask;
  }
  return undefined;
};